import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getEvaluationMarks'
})
export class GetEvaluationMarksPipe implements PipeTransform {

    transform(script: any, level: number, hasHeadPermission: boolean): string {
        if (!script || !script.Evaluations) {
            return '-';
        }

        // If user doesn't have head permission, return only marks
        if (!hasHeadPermission) {
            return script.marks || script.total_marks || '-';
        }

        // For head permission, return L1, L2, L3 marks based on evaluation level
        const evaluation = script.Evaluations.find((e: any) => e.level === level);

        if (!evaluation) {
            return '-';
        }

        return evaluation.total_marks?.toString() || '-';
    }

}
